
import * as Components from "./Sushidonnew"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "sushidonnew"
}

